import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import { dictionaries } from './locales';

export const initi18 = () => {
  console.log("Init Uderly dictionaries", dictionaries);

  i18next.use(initReactI18next)
    // .use(LanguageDetector)
    .use(Backend).init({
      debug: false,
      fallbackLng: 'en',
      saveMissing: true,
      resources: dictionaries
    });
}

export const changeLanguage = (language: string) => {
  console.log("Change Uderly language");
  i18next.changeLanguage(language);
}
